import { Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { IBet } from 'src/app/models/bet/bet';
import { IBetOutcome } from 'src/app/models/bet/betOutcome.interface';
import { IOutcomeAndCodeValue } from 'src/app/models/bet/betOutcomeAndCodeValue';
import { IBetTypeShowType } from 'src/app/models/betType/betTypeShowType.interface';
import { IOutcomeCodeValue } from 'src/app/models/betType/outcomeCodeValue.interface';
import { EventVM } from 'src/app/models/event/event';
import { ITicketItem } from 'src/app/models/ticket/ticketItem.inerface';
import { ITicketItemGroup } from 'src/app/models/ticket/ticketItemGroup.interface';
import { EventsService } from 'src/app/services/events.service';
import { SettingsService } from 'src/app/services/settings.service';
import { TicketService } from 'src/app/services/ticket.service';
import { UtilityService } from 'src/app/services/util/utility.service';
declare var $: any;
declare var window: any;

@Component({
  selector: 'app-cashier-search',
  templateUrl: './cashier-search.component.html',
  styleUrls: ['./cashier-search.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class CashierSearchComponent implements OnInit, OnDestroy {

  public showCodeButtons = false;
  public eventCode: string;
  public events: EventVM[];
  public eventsFromServer: EventVM[];
  public bets: IBet[] = [];
  public betOutcomes: IBetOutcome[] = [];
  public betOutcomeCode = '';
  public isSearchValid: boolean;
  public filteredOutcomesAndCodeValues: IOutcomeAndCodeValue[] = [];
  private outcomeCodeValues: IOutcomeCodeValue[];
  public betTypeShowTypes: { [betTypeId: number]: IBetTypeShowType } = null;
  public searchMessage = '';
  private oldSearchParam = '';
  private timeout;
  public liveEvents: EventVM[];
  public showLiveEvents = false;
  selectedEvent: EventVM;
  private focusOutEventCodeTimeout: NodeJS.Timeout;
  private ticketEventAndItemToEdit: { ticketItemGroup: ITicketItemGroup; ticketItem: ITicketItem };

  searchByExactCodeValue = true;

  private subscription: Subscription = new Subscription();

  htmlEl!: HTMLElement;

  timeoutfocus;
  clickFlag = false;

  @ViewChild('eventListener')
  set target(elementRef: ElementRef) {
    this.htmlEl = elementRef.nativeElement;
  }

  constructor(
    private eventsService: EventsService,
    private utilityService: UtilityService,
    private settingsService: SettingsService,
    private ticketService: TicketService) {
    settingsService.getBetTypeShowTypes().subscribe(btst => this.betTypeShowTypes = btst);
    settingsService.getOutcomeCodeValues().subscribe(ocv => this.outcomeCodeValues = ocv);
    this.subscription.add(
      ticketService.editTicketItem$.subscribe(ticketEventAndItemToEdit => {
        this.ticketEventAndItemToEdit = ticketEventAndItemToEdit;
        if (this.focusOutEventCodeTimeout) {
          clearTimeout(this.focusOutEventCodeTimeout);
        }
        this.editTicketItem(ticketEventAndItemToEdit.ticketItemGroup, ticketEventAndItemToEdit.ticketItem, ticketEventAndItemToEdit.editOutcome);
      }));
  }

  ngOnInit(): void {

    $('.eventcode-wrap input').focus(() => {
      // $('.searchable ul').hide();
      setTimeout(() => {
        $('.eventcode-wrap ul').show();
      }, 20);
      // console.log('fokus eventcode');
    });


    $('.eventcode-wrap input').focusout(() => {
      this.focusOutEventCodeTimeout = setTimeout(() => {
        $('.eventcode-wrap ul').hide();
        // console.log('fokusOut eventcode');
      }, 500);
    });

    $('.betcode-wrap input').focus(() => {
      // $('.searchable ul').hide();
      $('.betcode-wrap ul').show();
      // console.log('fokus betcode');
      // console.log(33);
    });

    $('.betcode-wrap input').focusout(() => {
      this.timeoutfocus = setTimeout(() => {
        $('.betcode-wrap ul').hide();
        // console.log('fokusOut betcode');
      }, 500);
    });

    $('.searchable input').blur(() => {
      const that = this;

      if ($(this).hasClass('eventcode-wrap')) {
        setTimeout(() => {
          $('.searchable ul').hide();
        }, 50);
      }
      // setTimeout(() => {
      //   // $(that).closest('.searchable').find('ul').hide();
      //   $('.searchable ul').hide();
      // console.log(24);

      // }, 300);
    });

    $(document).on('click', '.searchable ul li', () => {
      $(this).closest('.searchable').find('input').val($(this).text()).blur();
      // this.onSelect($(this).text());
    });

    $('.searchable ul li').hover(() => {
      $(this).closest('.searchable').find('ul li.selected').removeClass('selected');
      $(this).addClass('selected');
    });

    // document.body.addEventListener('keydown', (e) => {
    //   this.myFunction(e);
    // });


    window.addEventListener('keydown', this.eventListener);

    // this.htmlEl.addEventListener('keydown', this.eventListener, {
    //   passive: true
    // });

  }

  private eventListener = (e) => {
    // console.log(111);
    // This is the F1 key code, but NOT with SHIFT/CTRL/ALT
    const keyCode = e.keyCode || e.which;
    if ((keyCode === 112 || e.key === 'F1') && !(e.altKey || e.ctrlKey || e.shiftKey || e.metaKey)) {
      // prevent code starts here:
      this.removeDefaultFunction(e);
      // e.cancelable = true;
      // e.stopPropagation();
      // e.preventDefault();
      // e.returnValue = false;
      // Open help window here instead of alert
      // alert('F1 Help key opened, ' + keyCode);
      this.removeAllTicketItems();
      document.getElementById('eventCode').focus();
    } else if ((keyCode === 123 || e.key === 'F12') && !(e.altKey || e.ctrlKey || e.shiftKey || e.metaKey)) {
      this.removeDefaultFunction(e);
      this.getLiveEvents(e);

    } else if ((keyCode === 13 || e.key === 'NumpadEnter' || e.key === 'Enter') && !this.clickFlag) {
      // console.log(keyCode);
      // console.log(this.clickFlag);
      if (document.getElementById('totalStakeInput') === document.activeElement) {
        if (document.getElementsByClassName('ticket-dialog-wrap').length === 0) {
          $('.place-bet-wrap .btn').click();
          // console.log('.place-bet-wrap .btn');
          this.clickFlag = true;
        } else {
          // console.log('btnConfirmTicketConfirm click');
          document.getElementById('btnConfirmTicketConfirm').click();
          this.clickFlag = true;
        }
      } else if (document.getElementsByClassName('ticket-dialog-wrap').length !== 0) {
        // console.log('btnConfirmTicketConfirm 1 click');
        document.getElementById('btnConfirmTicketConfirm').click();
      } else if (document.getElementsByClassName('notification-dialog-wrap').length !== 0) {
        $('#notificationDialog .btn').click();
        // console.log('notificationDialog click');
      }
      setTimeout(() => {
        this.clickFlag = false;
      }, 500);
    }
  };

  editTicketItem(ticketItemGroup: ITicketItemGroup, ticketItem: ITicketItem, editOutcome: boolean) {
    this.eventCode = ticketItemGroup.eventCode;
    // this.betOutcomeCode = ticketItem.
    this.eventSearch(editOutcome);
  }

  removeDefaultFunction(e) {
    window.onhelp = () => false;

    // e.cancelable = true;
    e.stopPropagation();
    e.preventDefault();
    e.returnValue = false;
  }

  getLiveEvents(e) {
    // console.log('live events');
    e.preventDefault();
    setTimeout(() => {
      if (document.getElementById('eventCode')) {
        document.getElementById('eventCode').focus();
      }
    }, 150);
    if (this.liveEvents && this.liveEvents.length > 0) {
      return;
    }
    this.getAllLiveEventsFromServer();
  }

  removeAllTicketItems() {
    this.ticketService.removeAllTicketItems();
    // this.setIsTicketOnline();
  }

  eventSearchOnEnter() {
    this.selectEvent(this.events[0]);
  }

  outcomesSearchOnEnter() {
    // console.log('xssdsad');
    this.addItemToTicket(this.filteredOutcomesAndCodeValues[0].betOutcome);
  }

  eventSearch(editOutcome: boolean = true) {
    this.showLiveEvents = false;
    this.liveEvents = [];
    // clearTimeout(this.timeout);
    // console.log('usoooo');
    this.setIsSearchValid();
    if (!this.isSearchValid) {
      this.selectedEvent = null;
      this.bets = [];
      this.betOutcomes = [];
      this.filteredOutcomesAndCodeValues = [];
      return;
    }

    this.eventCode = this.eventCode.trim();
    if (this.eventCode.startsWith(this.oldSearchParam) && this.oldSearchParam.length > 0) {
      this.events = this.utilityService.sortEventsByCodeValueAndLength(this.eventsFromServer.filter(ev =>
        this.searchByExactCodeValue ?
          ev.code === this.eventCode :
          (ev.eventName.includes(this.eventCode) || ev.code.includes(this.eventCode))));
      if (this.events[0]?.code === this.ticketEventAndItemToEdit?.ticketItemGroup?.eventCode && this.eventCode === this.ticketEventAndItemToEdit?.ticketItemGroup?.eventCode) {
        if (editOutcome) {
          this.selectEvent(this.events[0]);
        } else {
          if (document.getElementById('eventCode')) {
            document.getElementById('eventCode').focus();
          }
        }
      }
    } else {
      // this.timeout = setTimeout(() => {
      this.getAllEventsForFilterFromServer(editOutcome);
      // }, 500);
    }
  }

  changeSearchOption() {
    this.searchByExactCodeValue = !this.searchByExactCodeValue;
    if (this.betOutcomeCode) {
      if (this.timeoutfocus) {
        clearTimeout(this.timeoutfocus);
      }
      console.log(document.activeElement.id);
      document.getElementById(document.activeElement.id).focus();
      console.log(document.activeElement);
      this.searchOutcomesByCode();
    }
  }

  searchOutcomesByCode() {
    if (this.searchByExactCodeValue) {
      this.filteredOutcomesAndCodeValues = this.eventsService.getOutcomesAndCodeValuesByCodeExact(this.betOutcomeCode, this.betOutcomes, this.outcomeCodeValues);
    } else {
      this.filteredOutcomesAndCodeValues = this.eventsService.getOutcomesAndCodeValuesByCodeBetsAndOutcomeProperties(this.betOutcomeCode, this.betOutcomes, this.bets, this.betTypeShowTypes, this.outcomeCodeValues);
    }
  }

  getAllEventsForFilterFromServer(editOutcome: boolean = true) {
    this.eventsService.getEventsByDateAndCode(this.eventCode).subscribe(events => {

      const soretedEv = this.utilityService.sortEventsByCodeValueAndLength(events);
      this.oldSearchParam = this.eventCode;
      this.eventsFromServer = soretedEv;
      if (this.searchByExactCodeValue) {
        this.events = events.filter(ev => ev.code === this.eventCode);
      } else {
        this.events = soretedEv;
      }
      if (this.events[0]?.code === this.ticketEventAndItemToEdit?.ticketItemGroup?.eventCode && this.eventCode === this.ticketEventAndItemToEdit?.ticketItemGroup?.eventCode) {
        if (editOutcome) {
          this.selectEvent(this.events[0]);
        } else {
          if (document.getElementById('eventCode')) {
            document.getElementById('eventCode').focus();
          }
        }
      }
      // console.log('novi eventi');
    });
  }

  getAllLiveEventsFromServer() {
    this.eventsService.getAllLiveEvents().subscribe(events => {
      this.liveEvents = this.utilityService.sortEventsByCodeValueAndLength(events);
      this.showLiveEvents = true;
    });
  }


  selectEvent(event: EventVM) {
    // console.log('selectEvent');
    this.selectedEvent = event;
    if (event) {
      this.eventCode = this.selectedEvent.code;
      this.eventsService.getBetsForEvent(this.selectedEvent, this.betTypeShowTypes).subscribe(betsAndOutcomes => {
        this.bets = betsAndOutcomes.bets;
        this.betOutcomes = betsAndOutcomes.betOutcomes;
        // console.log(this.betOutcomes);
        // console.log('dodao');
        document.getElementById('betCode').focus();
        this.searchOutcomesByCode();
        // this.setSearchMessageAfterSearch();
      });
    }
  }

  addItemToTicket(betOutcome: IBetOutcome) {
    // console.log('addItemToTicket');
    if (this.ticketService.isOutcomeInTicket(this.selectedEvent.id, betOutcome.id)) {
      this.resetSearchValues();
      // item allredy in ticket
      return;
    }

    this.ticketService.toggleEventOutcome(this.selectedEvent,
      this.bets.find(b => b.id === betOutcome.betId),
      betOutcome,
      this.betTypeShowTypes[betOutcome.betTypeId] && this.betTypeShowTypes[betOutcome.betTypeId].betTypeOutcomes[betOutcome.betTypeOutcomeId] ? this.betTypeShowTypes[betOutcome.betTypeId].betTypeOutcomes[betOutcome.betTypeOutcomeId].name : '',
      this.betTypeShowTypes[betOutcome.betTypeId] ? this.betTypeShowTypes[betOutcome.betTypeId].betTypeName : '');

    if (this.ticketEventAndItemToEdit) {
      this.ticketService.removeTicketItem(this.ticketEventAndItemToEdit.ticketItemGroup, this.ticketEventAndItemToEdit.ticketItem);
      this.ticketEventAndItemToEdit = null;
    }

    this.resetSearchValues();
  }

  private resetSearchValues() {
    this.eventCode = '';
    this.events = [];
    // this.eventsFromServer = [];
    this.bets = [];
    this.betOutcomes = [];
    this.betOutcomeCode = '';
    this.filteredOutcomesAndCodeValues = [];
    this.selectedEvent = null;
    this.showLiveEvents = false;
    this.liveEvents = [];
    document.getElementById('eventCode').focus();
  }

  setIsSearchValid() {
    const validation = this.utilityService.isSearchValid(this.eventCode);
    this.isSearchValid = validation.isSearchValid;
    this.searchMessage = validation.searchMessage;
    if (!this.isSearchValid) {
      this.events = [];
    }
  }

  filterFunction(event) {
    let container;
    let buttonType;
    // let input;
    // let filter;
    // let li;
    // let inputVal;
    // const par = event.srcElement.id;
    if (event.srcElement.id === 'eventCode') {
      container = $('.searchable.eventcode-wrap');
      buttonType = 1;
    } else {
      container = $('.searchable.betcode-wrap');
      buttonType = 2;
    }
    // inputVal = container.find('input').val().toUpperCase();

    if (['ArrowDown', 'ArrowUp', 'Enter'].indexOf(event.key) !== -1) {
      this.keyControl(event, container, buttonType);
    }
    // else {
    //     li = container.find('ul li');
    //     li.each((i, obj) => {
    //         if ($(this).text().toUpperCase().indexOf(inputVal) > -1) {
    //             $(this).show();
    //         } else {
    //             $(this).hide();
    //         }
    //     });

    //     container.find('ul li').removeClass('selected');
    //     setTimeout(() => {
    //         container.find('ul li:visible').first().addClass('selected');
    //     }, 100);
    // }
  }

  keyControl(e, container, buttonType) {
    if (e.key === 'ArrowDown') {

      if (container.find('ul li').hasClass('selected')) {
        if (container.find('ul li:visible').index(container.find('ul li.selected')) + 1 < container.find('ul li:visible').length) {
          container.find('ul li.selected').removeClass('selected').nextAll().not('[style*="display: none"]').first().addClass('selected');
        }

      } else {
        container.find('ul li:first-child').addClass('selected');
      }

      this.scrollFunction(container);

    } else if (e.key === 'ArrowUp') {

      if (container.find('ul li:visible').index(container.find('ul li.selected')) > 0) {
        container.find('ul li.selected').removeClass('selected').prevAll().not('[style*="display: none"]').first().addClass('selected');
      }
      this.scrollFunction(container);
    } else if (e.key === 'Enter') {
      // container.find('input').val(container.find('ul li.selected').text()).blur();

      // console.log('Enter');
      const el = container.find('ul li.selected');
      if ((this.liveEvents && this.liveEvents.length > 0) || (this.events && this.events.length > 0)) {
        if (el.length > 0) {
          if (buttonType === 1) {
            const codeField = container.find('ul li.selected').data('code');
            const eventCode = codeField ? codeField.toString() : '';
            let ev;
            if (!this.showLiveEvents) {
              ev = this.events.find(event => event.code === eventCode);
            } else {
              ev = this.liveEvents.find(event => event.code === eventCode);
            }
            if (ev) {
              this.selectEvent(ev);
            }
          } else {
            const btoId = container.find('ul li.selected').data('btoid');
            const betOutcomeId = btoId ? +btoId : null;
            const oacv = this.filteredOutcomesAndCodeValues.find(oav => oav.betOutcome.id === betOutcomeId);
            if (oacv) {
              this.addItemToTicket(oacv.betOutcome);
            }
          }
          // console.log(container.find('ul li.selected').data('event'));
        } else {
          if (buttonType === 1) {
            if (!this.showLiveEvents) {
              this.selectEvent(this.events[0]);
            } else {
              this.selectEvent(this.liveEvents[0]);
            }
          } else {
            this.addItemToTicket(this.filteredOutcomesAndCodeValues[0].betOutcome);
          }

        }
        $('.searchable ul').hide();
      } else if ((this.eventCode === undefined || this.eventCode === '') && document.getElementById('eventCode') === document.activeElement) {
        document.getElementById('totalStakeInput').focus();
        $('.searchable ul').hide();
      }

      // const test2 = container.find('ul li.selected');
      // this.onSelect(container.find('ul li.selected').text());
    }

    // container.find('ul li.selected')[0].scrollIntoView({
    //   behavior: 'smooth',
    // });
  }

  scrollFunction(container) {
    container.find('ul li.selected')[0].scrollIntoView({
      behavior: 'smooth',
      block: 'end',
      inline: 'nearest'
    });
  }

  ngOnDestroy(): void {
    window.removeEventListener('keydown', this.eventListener, false);
    this.subscription.unsubscribe();
  }
}
